import React from 'react';
import { NotificationItem } from './NotificationItem';
import { useNotification } from './NotificationContext';
import { NotificationProps } from './NotificationTypes';

/**
 * Container hiển thị tất cả các thông báo
 * Được đặt ở chính giữa phía trên của màn hình
 */
export const NotificationContainer: React.FC = () => {
  const { notifications, removeNotification } = useNotification();

  if (notifications.length === 0) {
    return null;
  }

  return (
    <div className='fixed left-1/2 top-4 z-[100000] -translate-x-1/2'>
      <div className='flex flex-col items-center space-y-3'>
        {notifications.map((notification: NotificationProps) => (
          <NotificationItem
            key={notification.id}
            notification={notification}
            onClose={() => notification.id && removeNotification(notification.id)}
          />
        ))}
      </div>
    </div>
  );
};
